import { Type } from '@angular/core';

import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FontAlignmentEnum } from '../../../Common/Forms/enums/font-alignment.enum';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';

export interface SocialLinksStyleDefaultsModel {
    alignment: FontAlignmentEnum;
    fontSize: string;
    italics: boolean;
    bold: boolean;
    underlined: boolean;
}

export class SocialLinksStyleFieldModel implements FormFieldModel {
    readonly defaults: SocialLinksStyleDefaultsModel = {
        alignment: FontAlignmentEnum.left,
        fontSize: '14px',
        italics: false,
        bold: false,
        underlined: false,
    };

    property: string;
    fieldComponent?: Type<AbstractFormFieldComponent>;
    label?: string;
    description?: string;
    styleType?: StyleTypesApiEnum;

    constructor(
        property: string,
        fieldComponent?: Type<AbstractFormFieldComponent>,
        label?: string,
        description?: string,
        styleType?: StyleTypesApiEnum,
    ){
        this.property = property;
        this.fieldComponent = fieldComponent;
        this.label = label;
        this.description = description;
        this.styleType = styleType;
    }

}
